import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Tabs, Tab } from '@heyroot/ui/primitives/Tabs';
import { TtvTrendsPanel } from '../components/onboarding-funnel/TtvTrendsPanel.js';
import { StepDropOffPanel } from '../components/onboarding-funnel/StepDropOffPanel.js';
import { StuckTenantWorklist } from '../components/onboarding-funnel/StuckTenantWorklist.js';

// Panels are wired in Tasks 9-11; this task ships the shell + shared
// business-type filter state (§4 "Shared filter" -- one control governs all
// three funnel-tab panels).
//
// The outer Tabs (Queue / Funnel Dashboard) is the ADDRESSABLE tab -- its
// active index is driven by which route is mounted (this page vs.
// onboarding-queue.tsx), and onChange navigates rather than setting local
// state, so deep links/back/forward/reload all preserve which tab is active
// (locked decision, spec §1a). The inner Tabs (TTV / Drop-off / Stuck
// Tenants) is a plain in-page tab switcher -- it does not need its own route.
export function OnboardingFunnelPage() {
  const navigate = useNavigate();
  const [businessTypeFilter, setBusinessTypeFilter] = useState<string | 'all'>('all');

  return (
    <div className="onboarding-funnel-page">
      <Tabs
        activeIndex={1}
        onChange={(i) => {
          if (i === 0) void navigate({ to: '/onboarding' });
        }}
      >
        <Tab label="Queue">
          <div data-testid="queue-tab-redirect-target" />
        </Tab>
        <Tab label="Funnel Dashboard">
          <div className="flex flex-col gap-4">
            <div>
              <h1 className="text-heading-2 text-primary">Onboarding Funnel</h1>
              <p className="mt-1 text-body-sm text-muted">
                TTV trends, per-step drop-off, and tenants stuck onboarding.
              </p>
            </div>
            <Tabs defaultIndex={0}>
              <Tab label="TTV Trends">
                <TtvTrendsPanel
                  businessTypeFilter={businessTypeFilter}
                  onBusinessTypeFilterChange={setBusinessTypeFilter}
                />
              </Tab>
              <Tab label="Step Drop-off">
                <StepDropOffPanel businessTypeFilter={businessTypeFilter} />
              </Tab>
              <Tab label="Stuck Tenants">
                <StuckTenantWorklist />
              </Tab>
            </Tabs>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}
